import { render } from "./GreenEconomy.vue?vue&type=template&id=15145912"
import script from "./GreenEconomy.vue?vue&type=script&lang=js"
export * from "./GreenEconomy.vue?vue&type=script&lang=js"

import "./GreenEconomy.vue?vue&type=style&index=0&id=15145912&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__